import type { ParseKeys } from "i18next";
import type { Room } from "livekit-client";
import type {
  ChatMessage,
  ReceivedChatMessage,
} from "@livekit/components-react";

import type { IVideoVisitSettingStep, IVisitSidebarItemEnum } from ".";

import type { ID } from "@constants";
import type { IJoinVideoVisit } from "@api/videoVisit";
import type { IRole } from "@/interfaces";

export interface IVideoVisitStore {
  title: ParseKeys<"common">;
  open: boolean;
  openVideoVisit: (
    id: ID,
    role: IVideoVisitRole,
    isGuest?: boolean,
    guestName?: string,
  ) => void;
  closeVideoVisit: () => void;
  step: IVideoVisitStepEnum;
  setStep: (step: IVideoVisitStepEnum) => void;
  data: IJoinVideoVisit | undefined;
  setData: (data: IJoinVideoVisit) => void;
  appointmentId: ID | undefined;
  settingStep: IVideoVisitSettingStep;
  setSettingStep: (step: IVideoVisitSettingStep) => void;
  settings: {
    mic: string | undefined;
    setMic: (id: string | undefined, label: string | undefined) => void;
    speaker: string | undefined;
    setSpeaker: (id: string | undefined, label: string | undefined) => void;
    cam: string | undefined;
    setCam: (id: string | undefined, label: string | undefined) => void;
    micLabel: string | undefined;
    camLabel: string | undefined;
    speakerLabel: string | undefined;
  };
  meetSettings: {
    mic: string | undefined;
    setMic: (id: string | undefined, label: string | undefined) => void;
    speaker: string | undefined;
    setSpeaker: (id: string | undefined, label: string | undefined) => void;
    cam: string | undefined;
    setCam: (id: string | undefined, label: string | undefined) => void;
    micLabel: string | undefined;
    camLabel: string | undefined;
    speakerLabel: string | undefined;
  };
  livekit: {
    room: Room | undefined;
    setRoom: (room: Room | undefined) => void;
  };
  minimize: boolean;
  setMinimize: (state: boolean) => void;
  layout: {
    topbarOpen: boolean;
    setTopbarOpen: (state: boolean) => void;
  };
  sound: {
    active: boolean;
    volume: number;
    setSound: (active: boolean, volume?: number) => void;
  };
  role: IVideoVisitRole;
  guestName: string;
  chats: ReceivedChatMessage[];
  setChats: (chats: ReceivedChatMessage[]) => void;
  hasNewMessage: boolean;
  setHasNewMessage: (state: boolean) => void;
  sidebarActiveKey: IVisitSidebarItemEnum | undefined;
  setSidebarActiveKey: (key: IVisitSidebarItemEnum | undefined) => void;
  sendChat: ((message: string) => Promise<ChatMessage>) | undefined;
  setSendChat: (
    func: ((message: string) => Promise<ChatMessage>) | undefined,
  ) => void;
}

export enum IVideoVisitStepEnum {
  LOADING = "LOADING",
  GUEST_LOADING = "GUEST_LOADING",
  REQUEST = "REQUEST",
  SETTING = "SETTING",
  JOINED = "JOINED",
}

export type IVideoVisitRole = IRole | "guest";
